import "./App.css";
import "./style/DashboardPage.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/principal";
import LoginPage from "./pages/login";
import Registro from "./pages/registro";
import DashboardPage from "./pages/DashboardPage";
import GestionSensores from "./pages/SensoresPage";
import SensorDetailPage from "./pages/SensorDetailPage";
import ProtectedRoute from "./components/ProtectedRoute";
import CalendarPage from "./pages/CalendarPage";
import TerrenosPage from "./pages/TerrenosPage";
import WeatherPage from "./pages/WeatherPage";
import ChatsPage from "./pages/ChatsPage";
import AlertasPage from "./pages/AlertasPage";
import Analicis from "./pages/Analicis";

function App() {
  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/registro" element={<Registro />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/devices"
            element={
              <ProtectedRoute>
                <GestionSensores />
              </ProtectedRoute>
            }
          />

          {/* RUTA DE DETALLES DEL SENSOR - DEBE IR ANTES DE LA RUTA GENÉRICA */}
          <Route
            path="/devices/:id"
            element={
              <ProtectedRoute>
                <SensorDetailPage />
              </ProtectedRoute>
            }
          />

          {/* RUTA ALTERNATIVA POR SI ACASO */}
          <Route
            path="/sensores/:id"
            element={
              <ProtectedRoute>
                <SensorDetailPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/terrenos"
            element={
              <ProtectedRoute>
                <TerrenosPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/weather"
            element={
              <ProtectedRoute>
                <WeatherPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/chats"
            element={
              <ProtectedRoute>
                <ChatsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/calendario"
            element={
              <ProtectedRoute>
                <CalendarPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/alertas"
            element={
              <ProtectedRoute>
                <AlertasPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/analicis"
            element={
              <ProtectedRoute>
                <Analicis />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<div>404 - Página no encontrada</div>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
